import { CommonModule } from "@angular/common";
import { Inject, ModuleWithProviders, NgModule } from "@angular/core";
import { TruncatePipe } from "@app/_pipes/truncate.pipe";
import { NgxTippyModule, NgxTippyService } from "ngx-tippy-wrapper";
import { DefaultProps, followCursor } from "tippy.js";
import { MAT_TOOLTIP_CONFIG, MatTooltipDirective } from "./mat-tooltip";
import { sameWidthPlugin } from "./tippy-extensions";

@NgModule({
	declarations: [MatTooltipDirective],
	imports: [CommonModule],
	exports: [MatTooltipDirective],
	providers: [
		{
			provide: MAT_TOOLTIP_CONFIG,
			useValue: <DefaultProps>{
				theme: "timeghost",
				arrow: true,
				inertia: true,
				animation: "timeghost-anim",
				duration: [100, 100],
				delay: 0,
				hideOnClick: true,
				plugins: [followCursor, sameWidthPlugin],
			},
		},
		TruncatePipe,
	],
})
export class MatTooltipTippyModule {
	constructor(
		private tippyService: NgxTippyService,
		@Inject(MAT_TOOLTIP_CONFIG) private tippyOptions: DefaultProps
	) {
		this.tippyService.setDefaultProps(this.tippyOptions);
	}

	static forRoot(): ModuleWithProviders<NgxTippyModule> {
		return {
			ngModule: NgxTippyModule,
		};
	}
}
